export const PARTNER_PRODUCTS_IN_SCOPE = [
  'Helix ITSM',
  'Helix Discovery',
  'Helix Digital Workplace (DWP)',
  'Helix Operations Management with AIOps',
  'Helix HelixGPT',
  'Helix CMDB',
  'Helix Customer Service Management (CSM)',
  'Helix Enterprise Service Management',
  'Helix Business Workflows',
  'Helix Multi-Cloud Broker',
  'Helix Network Management',
  'Helix Continuous Optimization',
  'Helix Portfolio Management',
];

export const PARTNER_ENGAGEMENT_TYPES = [
  'New Implementation',
  'Upgrade',
  'Expansion',
  'Migration',
  'Pilot / POC',
];

export const PARTNER_DEPLOYMENT_MODELS = ['SaaS', 'On-Premise', 'Hybrid'];

export const PARTNER_COMPETITIVE_CONTEXTS = [
  'Displacement (competitive win)',
  'Greenfield',
  'Expansion of existing Helix deployment',
];

export const DEFAULT_PARTNER_FORM_OPTIONS = {
  productsInScope: PARTNER_PRODUCTS_IN_SCOPE,
  engagementTypes: PARTNER_ENGAGEMENT_TYPES,
  deploymentModels: PARTNER_DEPLOYMENT_MODELS,
  projectStatus: [
    'Sales Cycle / Not Started',
    'Active',
    'Go-Live Complete',
    'Completed',
  ],
  competitiveContexts: PARTNER_COMPETITIVE_CONTEXTS,
};
